import './App.scss'
import { Route, Routes, BrowserRouter} from 'react-router';


import { Provider } from 'react-redux';
import store from './stores/store.ts';

import AuthProvider from './contexts/auth/AuthProvider.tsx';

import TradsProvider from './contexts/trads/TradsProvider.tsx';

import LoginPage from './pages/LoginPage.tsx';
import LostPage from './pages/LostPage.tsx';
import ResetPasswordPage from './pages/ResetPasswordPage.tsx';
import RegisterPage from './pages/RegisterPage.tsx';
import NoMatch from './pages/NoMatch.tsx';





import RoleRoute from './routes/Restrictions/RoleRoute.tsx';
import Layout from './pages/Layout.tsx';
import AuthLayout from './pages/AuthLayout.tsx';
import OtherLayout from './pages/OtherLayout.tsx';
import DonsLayout from './pages/DonsLayout.tsx';


import Home from './pages/Dashboard/Home.tsx';

import Demandes from './pages/Demandes/DemandeList.tsx';
import CreationDemande from './pages/Demandes/DemandeAdd.tsx';
import Demande from './pages/Demandes/DemandeItem.tsx';
import DemandeEdit from './pages/Demandes/DemandeEdit.tsx';

import Profil from './pages/Profil/Profil.tsx';
import ProfilEdit from './pages/Profil/ProfilEdit.tsx';

import Fonds from          './pages/Fonds/FondsList.tsx';
import FondView from       './pages/Fonds/FondItem.tsx';
import FondAdd from './pages/Fonds/FondAdd.tsx';
import FondEdit from './pages/Fonds/FondEdit.tsx';
import FondBeneficiaires from './pages/Fonds/FondBeneficiaires.tsx';
import FondOperators from './pages/Fonds/FondOperators.tsx';

import UserAddPage from    './pages/Users/UserAdd.tsx';
import UserEditPage from   './pages/Users/UserEdit.tsx';
import UsersListPage from  './pages/Users/UsersList.tsx';
import UserViewPage from   './pages/Users/UserItem.tsx';


import BlocsAdd from './pages/Blocs/BlocsAdd.tsx';
import BlocsEdit from './pages/Blocs/BlocsEdit.tsx';
import Blocs from './pages/Blocs/BlocsList.tsx';
import BlocsView from './pages/Blocs/BlocsItem.tsx';

import Metas from './pages/Metas/MetasList.tsx';
import MetasAdd from './pages/Metas/MetasAdd.tsx';
import MetasEdit from './pages/Metas/MetasEdit.tsx';
import MetasView from './pages/Metas/MetasItem.tsx';

import TransactionList from './pages/Transactions/TransactionList.tsx';
import TransactionAdd from './pages/Transactions/TransactionAdd.tsx';
import TransactionItem from './pages/Transactions/TransactionItem.tsx';

import TypeFraisAdd from './pages/TypeFrais/TypeFraisAdd.tsx';
import TypeFraisEdit from './pages/TypeFrais/TypeFraisEdit.tsx';
import TypeFraisView from './pages/TypeFrais/TypeFraisItem.tsx';
import TypeFraisList from './pages/TypeFrais/TypeFraisList.tsx';
import UserManager from './pages/Users/UserManager.tsx';


import { roles } from './types/Users.ts';
import Traductions from './pages/Traductions/TraductionsList.tsx';
import TraductionsAdd from './pages/Traductions/TraductionsAdd.tsx';
import TraductionsEdit from './pages/Traductions/TraductionsEdit.tsx';
import TraductionsItem from './pages/Traductions/TraductionsItem.tsx';


import ReglementsAdd from './pages/Reglements/ReglementsAdd.tsx';
import ReglementsEdit from './pages/Reglements/ReglementsEdit.tsx';
import Reglements from './pages/Reglements/ReglementsList.tsx';
import ReglementsView from './pages/Reglements/ReglementsItem.tsx';
import ReglementCourant from './pages/Reglements/ReglementCourant.tsx';

import FondPerso from './pages/Fonds/FondPerso.tsx';
import FondPersoEdit from './pages/Fonds/FondPersoEdit.tsx';


import DonsList from './pages/Dons/DonsList.tsx';
import DonsItem from './pages/Dons/DonsItem.tsx';
import DonsAdd from './pages/Dons/DonsAdd.tsx';

import Donations from './pages/Appels/AppelsList.tsx';
import DonationItem from './pages/Appels/AppelItem.tsx';
import LogsList from './pages/Logs/LogsList.tsx';
import LogsItem from './pages/Logs/LogsItem.tsx';



import Pages from     './pages/Pages/PagesList.tsx';
import PagesAdd from  './pages/Pages/PagesAdd.tsx';
import PagesEdit from './pages/Pages/PagesEdit.tsx';
import PagesItem from './pages/Pages/PagesItem.tsx';


function App() {

  return (
    <Provider store={store}>
      <TradsProvider>
      <BrowserRouter basename="/dashboard">
        <AuthProvider>
          <Routes >
              <Route element={<AuthLayout />}>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/lost" element={<LostPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/resetpassword" element={<ResetPasswordPage />} />
              </Route>
              <Route path="/" element={<RoleRoute role={roles.PasValider}><Layout /></RoleRoute>}>
                <Route index element={<Home />} />
              </Route>

              <Route path="/demande" element={<RoleRoute role={roles.Beneficiaires}><Layout /></RoleRoute>}>
                <Route index element={<Demandes  />} />
                <Route path="add" element={<CreationDemande />} />
                <Route path=":demandeId" >
                  <Route index  element={<Demande />} />
                  <Route path="edit" element={<DemandeEdit />} />
                </Route>
              </Route>

                <Route path="/user"  element={<RoleRoute role={roles.Operators}><Layout /></RoleRoute>} >
                  <Route index element={<UsersListPage />} />
                  <Route path=":userId" element={<UserViewPage />} />
                </Route>
                <Route path="/user"  element={<RoleRoute role={roles.Manager}><Layout /></RoleRoute>} >
                    <Route path="add" element={<UserAddPage />} />
                    <Route path=":userId/edit" element={<UserEditPage />} />
                </Route>
                <Route path="/user"  element={<RoleRoute role={roles.Administrators}><Layout /></RoleRoute>} >
                  <Route path=":userId/managers" element={<UserManager />} />
                </Route>

                <Route path="fond"  element={<RoleRoute role={roles.Operators}><Layout /></RoleRoute>}>
                  <Route index element={<Fonds />} />
                  <Route path=":fondId" element={<FondView />} />
                </Route> 

                <Route path="fond"  element={<RoleRoute role={roles.Manager}><Layout /></RoleRoute>}>

                  <Route path="add" element={<FondAdd />} />
                  <Route path=":fondId/edit" element={<FondEdit />} />
                  <Route path=":fondId/operators" element={<FondOperators />} />
                  <Route path=":fondId/beneficiaires" element={<FondBeneficiaires />} />
                  <Route path=":fondId/transaction" element={<TransactionAdd />} />
                </Route> 
                <Route path="perso"   element={<RoleRoute role={roles.PasValider}><Layout /></RoleRoute>}>
                  <Route index element={<FondPerso />} />
                  <Route path="edit" element={<FondPersoEdit />} />

                </Route>




                <Route path="type_frais" element={<RoleRoute role={roles.Administrators}><Layout /></RoleRoute>}>
                  <Route index  element={<TypeFraisList  />} />
                  <Route path="add" element={<TypeFraisAdd />} />
                  <Route path=":id" element={<TypeFraisView />} />
                  <Route path=":id/edit" element={<TypeFraisEdit />} />
                </Route>

                <Route path="transactions"  element={<RoleRoute role={roles.Manager}><Layout /></RoleRoute>}>
                  <Route index  element={<TransactionList />} />
                  <Route path="add" element={<TransactionAdd />} />
                  <Route path=":id" element={<TransactionItem />} />
                </Route>

                <Route path="metas" element={<RoleRoute role={roles.Administrators}><Layout /></RoleRoute>}>
                  <Route index  element={<Metas />} />
                  <Route path="add" element={<MetasAdd />} />
                  <Route path=":id" element={<MetasView />} />
                  <Route path=":id/edit" element={<MetasEdit />} />
                </Route>

                <Route path="blocs"  element={<RoleRoute role={roles.Administrators}><Layout /></RoleRoute>}>
                  <Route index  element={<Blocs />} />
                  <Route path="add" element={<BlocsAdd />} />
                  <Route path=":id" element={<BlocsView />} />
                  <Route path=":id/edit" element={<BlocsEdit />} />
                </Route>


                <Route path="pages"  element={<RoleRoute role={roles.Administrators}><Layout /></RoleRoute>}>
                  <Route index  element={<Pages />} />
                  <Route path="add" element={<PagesAdd />} />
                  <Route path=":id" element={<PagesItem />} />
                  <Route path=":id/edit" element={<PagesEdit />} />
                </Route>


                <Route path="reglements"  element={<RoleRoute role={roles.Administrators}><Layout /></RoleRoute>}>
                  <Route index  element={<Reglements />} />
                  <Route path="add" element={<ReglementsAdd />} />
                  <Route path=":id/edit" element={<ReglementsEdit />} />
                  <Route path=":id" element={<ReglementsView />} />
                </Route>
                <Route path="dons"  element={<RoleRoute role={roles.Administrators}><Layout /></RoleRoute>}>
                  <Route index  element={<DonsList />} />
                  <Route path=":id" element={<DonsItem />} />
                </Route>

                <Route path="logs"  element={<RoleRoute role={roles.Administrators}><Layout /></RoleRoute>}>
                  <Route index  element={<LogsList />} />
                  <Route path=":id" element={<LogsItem />} />
                </Route>

                {/* Tout le monde y a acces */}
                <Route element={<OtherLayout />}>
                  <Route path="rgu" element={<ReglementCourant />}></Route>
                </Route>

                <Route path="traductions"  element={<RoleRoute role={roles.Administrators}><Layout /></RoleRoute>}>
                  <Route index  element={<Traductions />} />
                  <Route path="add" element={<TraductionsAdd />} />
                  <Route path=":id" element={<TraductionsItem />} />
                  <Route path=":id/edit" element={<TraductionsEdit />} />
                </Route>


              <Route path="/profil" element={<RoleRoute role={roles.PasValider}><Layout /></RoleRoute>}> 
                <Route index element={<Profil />} />
                <Route path="edit" element={<ProfilEdit />} />
              </Route>

              <Route path="/appels" element={<DonsLayout />}> 
                <Route index element={<Donations />} />
                <Route path=":id" element={<DonationItem />} />
              </Route>
              <Route path="/donations" element={<DonsLayout />} >
                <Route path=":id"  element={<DonsAdd />} />
              </Route>


              {/* Using path="*"" means "match anything", so this route
                  acts like a catch-all for URLs that we don't have explicit
                  routes for. */}
              <Route element={<OtherLayout />}>
                <Route path="*" element={<NoMatch />} />
              </Route>
            
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      </TradsProvider>
    </Provider>
  )
}


export default App;